import clsx from 'clsx'
import { SIDENAV_WIDTH } from './constants'

export type SideNavContainerProps = {
  /** Content to render inside the sidebar */
  children: React.ReactNode
  /** Additional className for the outer container */
  className?: string
  /** Forwarded to the outer container element. Set by the consuming variant (Dashboard/Matter) so the DS Inspector can identify which one is rendered. */
  'data-ds-component'?: string
  /** Forwarded alongside `data-ds-component`. Distinguishes Dashboard vs Matter variants. */
  'data-ds-variant'?: string
}

/**
 * Container component for the SideNav.
 *
 * Provides:
 * - Fixed 254px width
 * - Background color and overflow handling
 */
export function SideNavContainer({ children, className, ...props }: SideNavContainerProps) {
  return (
    <div {...props} className={clsx('flex h-full', className)}>
      <div className="inset-y-0 z-50 flex flex-col overflow-hidden" style={{ width: SIDENAV_WIDTH }}>
        <div className="h-full flex flex-col overflow-y-auto overflow-x-clip bg-brand-neutral-50">{children}</div>
      </div>
    </div>
  )
}
